import type { FetchWerklijstenFilters } from '../types/FetchWerklijsten'

export { pickDashboardFilters }

type DashboardFilters = Pick<
  FetchWerklijstenFilters,
  | 'gebied'
  | 'labels'
  | 'myList'
  | 'startUitvoeringWeekVan'
  | 'startUitvoeringWeekTot'
  | 'verantwoordelijke'
  | 'processtatus'
  | 'typeWerk'
  | 'gemeente'
>

const pickDashboardFilters = ({
  gebied,
  labels,
  myList,
  startUitvoeringWeekVan,
  startUitvoeringWeekTot,
  verantwoordelijke,
  processtatus,
  typeWerk,
  gemeente,
}: DashboardFilters): DashboardFilters => ({
  gebied,
  labels,
  myList,
  startUitvoeringWeekVan,
  startUitvoeringWeekTot,
  verantwoordelijke,
  processtatus,
  typeWerk,
  gemeente,
})
